import { AssistantChatEffects } from '@pages/assistant/chat/chat.effects';
import { AssistantSubscriptionEffects } from '@pages/assistant/subscription/subscription.effects';
import { HealthGuidelineEffects } from '@pages/report/active/health-guideline/health-guideline.effects';
import { TrackerCoreEffects } from '@pages/tracker/effects/tracker-core.effects';
import { TrackerDetailEffects } from '@pages/tracker/effects/tracker-detail.effects';
import { TrackerOverviewEffects } from '@pages/tracker/effects/tracker-overview.effects';
import { TrackerSettingsEffects } from '@pages/tracker/effects/tracker-settings.effects';
import { AnalyticEffects } from '../components/analytic/analytic.effects';
import { AuthEffects } from '../components/auth/auth.effects';
import { AvatarDisplayEffects } from '../components/avatar/display/avatar-display.effects';
import { DnaReportAvatarEffects } from '../components/avatar/dna-report-avatar/dna-report-avatar.effects';
import { AvatarNotificationModalEffects } from '../components/avatar/notification-modal/notification-modal.effects';
import { ProductUnlockEffects } from '../components/home/product/unlock/unlock.effects';
import { OneSignalEffects } from '../components/one-signal/one-signal.effect';
import { ReminderEffects } from '../components/reminder/reminder.effects';
import { AvatarCreateEffects } from './avatar/create/create.effects';
import { DailyActivityEffects } from './daily/activity/activity.effect';
import { DailyJournalEffects } from './daily/journal/journal.effects';
import { HomeMyHealthPassportHealthRecordEffects } from './home-v3/my-health-passport/health-record/health-record.effects';
import { HomeMyRecommendationGeneralHealthEffects } from './home-v3/my-recommendation/general-health/general-health.effects';
import { OcrEffects } from './lwb/medical/ocr/ocr.effects';
import { LWBPeriscopeEffects } from './lwb/periscope/periscope.effects';
import { ProdigyHealthGuidelineEffects } from './prodigy/health-guideline/health-guideline.effects';
import { ProdigyEffects } from './prodigy/prodigy.effects';
import { ProfileQuestionnaireEffects } from './profile/questionnaire/questionnaire.effects';
import { QuestionnaireActiveEffects } from './questionnaire/active/active.effects';
import { QuestionnaireGeneralEffects } from './questionnaire/general/general.effects';
import { QuestionnaireNourishEffects } from './questionnaire/nourish/nourish.effects';
import { QuestionnaireQuickAccessModalEffects } from './questionnaire/quick-access-modal/quick-access-modal.effects';
import { QuestionnaireTenxEffects } from './questionnaire/tenx/tenx.effects';
import { ReportAncestryEffects } from './report/ancestry/ancestry.effects';
import { NutritionGuideEffects } from './report/nourish/nutrition-guide/nutrition-guide.effects';
import { RecalculateEffects } from './report/nourish/recalculate/recalculate.effects';
import { ReportPersonaHealthGuidelineEffects } from './report/persona/health-guideline/health-guideline.effects';
import { ReportEffects } from './report/report.effects';
import { ReportSkinHealthGuidelineAnalysisEffects } from './report/skin/health-guideline/analysis/analysis.effects';
import { ReportSkinHealthGuidelineEffects } from './report/skin/health-guideline/health-guideline.effects';
import { ReportSkinHealthGuidelineTakePictureEffects } from './report/skin/health-guideline/take-picture/take-picture.effects';
import { ReportViewSearchEffects } from './report/view/search/search.effects';
import { ReportViewTraitResultEffects } from './report/view/trait/result/result.effects';
import { ReportViewTraitEffects } from './report/view/trait/trait.effects';
import { ReportViewEffects } from './report/view/view.effects';
import { ShopCatalogEffects } from './shop/catalog/catalog.effects';
import { ShopOrderEffects } from './shop/order/order.effects';

export const effects = [
  AuthEffects,
  AnalyticEffects,
  AvatarNotificationModalEffects,
  AvatarDisplayEffects,
  DnaReportAvatarEffects,
  AvatarCreateEffects,
  DailyJournalEffects,
  DailyActivityEffects,
  HomeMyHealthPassportHealthRecordEffects,
  HomeMyRecommendationGeneralHealthEffects,
  LWBPeriscopeEffects,
  OcrEffects,
  ProdigyEffects,
  ProdigyHealthGuidelineEffects,
  ProfileQuestionnaireEffects,
  ProductUnlockEffects,
  OneSignalEffects,
  ReminderEffects,
  ReportEffects,
  ReportViewEffects,
  ReportViewTraitEffects,
  ReportViewTraitResultEffects,
  ReportViewSearchEffects,
  ReportPersonaHealthGuidelineEffects,
  ReportSkinHealthGuidelineEffects,
  ReportSkinHealthGuidelineTakePictureEffects,
  ReportSkinHealthGuidelineAnalysisEffects,
  ShopOrderEffects,
  TrackerCoreEffects,
  TrackerDetailEffects,
  TrackerOverviewEffects,
  TrackerSettingsEffects,
  QuestionnaireNourishEffects,
  QuestionnaireTenxEffects,
  QuestionnaireActiveEffects,
  QuestionnaireGeneralEffects,
  QuestionnaireQuickAccessModalEffects,
  HealthGuidelineEffects,
  AssistantChatEffects,
  AssistantSubscriptionEffects,
  ShopCatalogEffects,
  ReportAncestryEffects,
  NutritionGuideEffects,
  RecalculateEffects
];
